import { forwardRef } from 'react';

import { TProps } from '../types/TProps';

export const IconButtonRegular = forwardRef<HTMLButtonElement, TProps>(
  ({ className, type = 'button', ...props }, ref) => (
    <button ref={ref} type={type} className={['icon-btn-regular', className].filter(Boolean).join(' ')} {...props} />
  ),
);

IconButtonRegular.displayName = 'IconButton';
